import { render } from "./FindCompanySkills.vue?vue&type=template&id=467b5936&scoped=true&ts=true"
import script from "./FindCompanySkills.vue?vue&type=script&lang=ts"
export * from "./FindCompanySkills.vue?vue&type=script&lang=ts"

import "./FindCompanySkills.vue?vue&type=style&index=0&id=467b5936&lang=scss&scoped=true"

import exportComponent from "/home/satou/deinjobfuchs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-467b5936"]])

export default __exports__